function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#47dfed;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M20.369,0H3.7A3.707,3.707,0,0,0,0,3.7v11.11a3.707,3.707,0,0,0,3.7,3.7v4.629a.927.927,0,0,0,.926.926.916.916,0,0,0,.6-.224l6.222-5.331h8.916a3.707,3.707,0,0,0,3.7-3.7V3.7A3.707,3.707,0,0,0,20.369,0ZM22.22,14.814a1.855,1.855,0,0,1-1.852,1.852H11.11a.911.911,0,0,0-.6.224L5.555,21.133V17.591a.926.926,0,0,0-.926-.926H3.7a1.855,1.855,0,0,1-1.852-1.852V3.7A1.855,1.855,0,0,1,3.7,1.852H20.369A1.855,1.855,0,0,1,22.22,3.7Z"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(9.388 5.721)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M180,98.915a.926.926,0,1,0-.6,1.752,1.831,1.831,0,0,1,1.228,1.735v11.11a1.855,1.855,0,0,1-1.852,1.852h-.926a.926.926,0,0,0-.926.926v3.542l-4.953-4.244a.911.911,0,0,0-.6-.224h-8.2a.926.926,0,1,0,0,1.852h7.86l6.222,5.331a.921.921,0,0,0,.989.139.926.926,0,0,0,.539-.841v-4.629a3.707,3.707,0,0,0,3.7-3.7V102.4A3.685,3.685,0,0,0,180,98.915Z",
  transform: "translate(-162.24 -98.864)"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(5.555 5.555)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M108.036,96H96.926a.926.926,0,0,0,0,1.852h11.11a.926.926,0,1,0,0-1.852Z",
  transform: "translate(-96 -96)"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(5.555 9.258)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M104.333,160H96.926a.926.926,0,1,0,0,1.852h7.407a.926.926,0,1,0,0-1.852Z",
  transform: "translate(-96 -160)"
}));

var SvgCharla = function SvgCharla(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29.627,
    height: 29.627,
    viewBox: "0 0 29.627 29.627",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCharla, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/charla.8c353d33.svg";
export { ForwardRef as ReactComponent };